import { render, staticRenderFns } from "./orderStatusDialogGoods.vue?vue&type=template&id=7fa1c6e7&scoped=true&"
import script from "./orderStatusDialogGoods.vue?vue&type=script&lang=js&"
export * from "./orderStatusDialogGoods.vue?vue&type=script&lang=js&"
import style0 from "./orderStatusDialogGoods.vue?vue&type=style&index=0&id=7fa1c6e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa1c6e7",
  null
  
)

export default component.exports